var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Setting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-setting",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M10.562,20H8.238a1,1,0,0,1-.987-.841l-.17-1A2.016,2.016,0,0,0,6.02,16.7a5.52,5.52,0,0,1-.74-.43,1.988,1.988,0,0,0-1.08-.321H4.193a1.9,1.9,0,0,0-.693.13l-1,.361a.844.844,0,0,1-.338.07H2.15a1,1,0,0,1-.859-.5l-1.16-2A1,1,0,0,1,.37,12.735l.8-.661a2.013,2.013,0,0,0,.72-1.643V9.569a2.01,2.01,0,0,0-.72-1.642l-.8-.661A1,1,0,0,1,.13,5.992l1.139-2a1.007,1.007,0,0,1,.86-.5h.013a.844.844,0,0,1,.338.07l1,.361a1.882,1.882,0,0,0,.687.13H4.18a2,2,0,0,0,1.08-.32A5.45,5.45,0,0,1,6,3.3,2.015,2.015,0,0,0,7.02,1.844l.17-1A1,1,0,0,1,8.177,0H10.5a1,1,0,0,1,.987.842l.17,1A2.012,2.012,0,0,0,12.721,3.3a5.451,5.451,0,0,1,.74.431,1.99,1.99,0,0,0,1.08.32h.014a1.882,1.882,0,0,0,.687-.13l1-.361a.858.858,0,0,1,.337-.07h.013a1,1,0,0,1,.86.5l1.16,2a1,1,0,0,1-.23,1.273l-.8.661a2.01,2.01,0,0,0-.72,1.642v.862a2.013,2.013,0,0,0,.72,1.643l.789.661a1,1,0,0,1,.3,1.273l-1.16,2a1.007,1.007,0,0,1-.86.5h-.013a.865.865,0,0,1-.337-.07l-1-.361a1.9,1.9,0,0,0-.693-.13H14.6a1.988,1.988,0,0,0-1.08.321,5.521,5.521,0,0,1-.74.43,2.016,2.016,0,0,0-1.06,1.453l-.169,1A1,1,0,0,1,10.562,20ZM9.37,4.489A5.514,5.514,0,1,0,14.87,10,5.512,5.512,0,0,0,9.37,4.489ZM9.37,12a2,2,0,1,1,2-2A2,2,0,0,1,9.37,12Z",
    transform: "translate(2.63 2)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Setting);
export default __webpack_public_path__ + "static/media/icon-24-setting.0823406484c585b84198004ad94bc322.svg";
export { ForwardRef as ReactComponent };